module.exports={pagination:{ListQueues:{result_key:"QueueUrls"}}};